var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.19165,
    height: 500,
    viewBox: "0 0 56.671536 132.29165",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.2399754e-4,-164.70863)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE201  \\uE1F1\\uE202   \\uE1F1\\uE203",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4452",
    transform: "matrix(10.656437,0,0,10.656497,-222.74223,-2175.8406)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5E7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4600",
    transform: "matrix(15.566253,0,0,15.566253,-0.00180614,-4326.1798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.4291242,291.42261 c 0,-0.10583 -0.042333,-0.11641 -0.1058333,-0.11641 -0.0635,0 -0.084667,0.0317 -0.1058334,0.0847 0,0 -0.010583,0.0106 -0.010583,0.0212 -0.084667,0.20108 -0.1481667,0.35983 -0.3280833,0.35983 -0.042333,0 -0.084667,0 -0.1481667,-0.0212 -0.1058333,-0.0423 -0.1693333,-0.0529 -0.254,-0.0953 -0.1693333,-0.0635 -0.5609166,-0.20109 -0.9101666,-0.20109 -0.1058333,0 -0.22225,0.0212 -0.3175,0.0529 0.1905,-0.30692 0.9101666,-0.56092 1.1006666,-0.61383 0.127,-0.0317 0.47625,-0.0952 0.762,-0.32809 0.2010833,-0.15875 0.3598333,-0.40216 0.3598333,-0.78316 0,-0.39159 -0.1693333,-0.67734 -0.3915833,-0.86784 -0.4339167,-0.35983 -1.0900833,-0.41275 -1.2805833,-0.41275 -0.22225,0 -0.508,0.0106 -0.73025,0.0529 -0.29633329,0.0635 -0.59266662,0.24342 -0.79374995,0.47625 -0.14816666,0.17992 -0.24341666,0.39158 -0.24341666,0.62442 0,0.11641 0.03175,0.23283 0.07408334,0.35983 0.12699999,0.26458 0.39158332,0.46567 0.69849997,0.46567 0.5185833,0 0.5926667,-0.52917 0.5926667,-0.74084 0,-0.508 -0.58208336,-0.53975 -0.58208336,-0.70908 0.0105833,-0.11642 0.16933333,-0.3175 0.66674996,-0.3175 0.7514167,0 0.762,0.56092 0.762,0.81492 0,0.3175 -0.1058333,0.61383 -0.28575,0.85725 -0.3069167,0.41275 -0.53975,0.61383 -0.9630833,0.86783 -0.46566665,0.29633 -0.79374998,0.70908 -0.93133331,1.23825 0,0.0212 -0.01058333,0.0423 -0.01058333,0.0529 0,0.0953 0.05291667,0.20108 0.14816666,0.26458 0.03175,0.0212 0.0529167,0.0212 0.0740833,0.0212 0.17991666,0 0.28574999,-0.51859 0.78316668,-0.51859 0.3386667,0 0.4656666,0.45509 1.2170833,0.45509 0.3704166,0 1.016,-0.0317 1.1535833,-1.34409 z m -0.5291667,4.08517 v -1.80975 c 0,-0.0635 -0.010583,-0.14817 -0.1058333,-0.14817 -0.074083,0 -0.1164167,0.0212 -0.1693333,0.0847 l -0.8043333,0.97367 c -0.03175,0.0423 -0.074083,0.0847 -0.074083,0.1905 v 0.70908 H 0.60337428 c 0.67733332,-0.5715 2.03199992,-2.49767 2.05316662,-2.59292 0,-0.0106 0.010583,-0.0212 0.010583,-0.0423 0,-0.0635 -0.0635,-0.11642 -0.127,-0.11642 -0.074083,0 -0.4233333,0.0212 -0.5715,0.0212 -0.15875,0 -0.5397499,-0.0212 -0.6032499,-0.0212 -0.074083,0 -0.2010834,0.0318 -0.2010834,0.15875 0,1.05834 -0.82549995,2.23309 -1.07949994,2.58234 l -0.05291667,0.0741 c 0,0.0106 -0.01058333,0.0106 -0.01058333,0.0212 -0.01058333,0.0317 -0.021166665,0.0741 -0.021166665,0.0953 0,0.0847 0.063499995,0.14816 0.169333325,0.14816 H 1.7463742 v 0.52917 c 0,0.23283 -0.1905,0.29633 -0.3386666,0.29633 -0.1375833,0 -0.2010833,0.0741 -0.2010833,0.15875 0,0.0847 0.042333,0.17992 0.1693333,0.17992 h 1.7991666 c 0.084667,0 0.1693333,-0.0635 0.1693333,-0.17992 0,-0.11641 -0.1058333,-0.16933 -0.1905,-0.16933 -0.084667,0 -0.254,-0.0529 -0.254,-0.3175 v -0.49742 h 0.6138334 c 0.084667,0 0.127,-0.0635 0.127,-0.16933 0,-0.0953 -0.03175,-0.15875 -0.127,-0.15875 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4602"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs24);
export default __webpack_public_path__ + "static/media/ts-2-4.61ae90ff30411cee61a2c078009d7a66.svg";
export { ForwardRef as ReactComponent };